import React from "react";
import SalesSideBar from "../../components/sales/SalesSideBar";
import commoncss from "../../css/common.module.css";

export default function Dashboard() {
  return (
    <>
      <div style={{ display: "flex" }}>
        <SalesSideBar activeTab={"Dashboard"} />
        <div className={`${commoncss.widthScrHidden} px-3 py-2`}>
          <h2>Dashboard</h2>
        </div>
      </div>
    </>
  );
}
